import React, { Component } from "react";
import {
  PageHeader, Row, Col, Card, Spin, Empty, message,
  Table, Select, Space, Tooltip, Typography, Tabs,
} from "antd";
import { TeamOutlined, TrophyOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import {
  Form, FormItem, ButtonItem, SelectItem, RangePickerItem, SelectVendedoresItem,
} from "../../../../Components/Items";
import { HeaderEmpresaCard } from "../../../../Components/PdfComponents/HeaderEmpresaCard";
import { ResponsiveBar } from "@nivo/bar";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const COLORES_NIVO = [
  "#4e79a7","#f28e2b","#e15759","#76b7b2",
  "#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ac",
];

const fmt = (val) =>
  `$${(val ?? 0).toLocaleString("es-MX", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

const CARD_STYLE = { borderRadius: 10, overflow: "hidden" };

const COLORES_PDF = [
  "#4e79a7","#f28e2b","#e15759","#76b7b2",
  "#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ac",
];

const PDF_STYLES = {
  header:               { fontSize: 9, bold: true },
  subheader:            { fontSize: 8, bold: true },
  tableExample:         { margin: [0, 5, 0, 5] },
  tableHeader:          { bold: true, fontSize: 12, color: "black", alignment: "center" },
  tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
  textoChico:           { fontSize: 8 },
  tituloTabla:          { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "center" },
  textoTabla:           { fontSize: 7 },
  totalChico:           { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "right" },
};

const buildBarras = (datos, getVal, getLabel, fmtFn = String) => {
  const maxV = Math.max(...datos.map(getVal), 1);
  const W = 190, H = 12, G = 5;
  return {
    columns: [
      {
        width: W,
        canvas: datos.map((d, i) => ({
          type: "rect", x: 0, y: i * (H + G),
          w: Math.max(2, Math.round((getVal(d) / maxV) * W)),
          h: H, color: COLORES_PDF[i % COLORES_PDF.length], r: 2,
        })),
      },
      {
        width: "*",
        margin: [8, 0, 0, 0],
        stack: datos.map((d) => ({
          text: `${getLabel(d)}  ${fmtFn(getVal(d))}`,
          style: "textoTabla", color: "#444", margin: [0, 2, 0, G - 2],
        })),
      },
    ],
    margin: [0, 4, 0, 10],
  };
};

class ReporteEquipoCRM extends Component {
  formRef = React.createRef();

  state = {
    loading:      false,
    datosRanking: [],
    embudos:      [],
    periodoStr:   "",
  };

  componentDidMount() {
    this.cargarEmbudos();
  }

  cargarEmbudos = async () => {
    const defaultValues = { periodo: [moment().startOf("year"), moment()] };
    try {
      const res = await axios.post(
        "embudos/selectEmbudosItem",
        { empresaId: this.props.empresaId, query: "" },
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2) {
        this.setState({ embudos: res.data.embudos ?? [] }, () => {
          this.onFinish(defaultValues);
        });
      } else {
        this.onFinish(defaultValues);
      }
    } catch {
      this.onFinish(defaultValues);
    }
  };

  onFinish = (values) => {
    const { periodo, embudoId, vendedorId } = values;
    const periodoStr = periodo
      ? `${periodo[0].format("DD/MM/YYYY")} - ${periodo[1].format("DD/MM/YYYY")}`
      : "Histórico completo";
    this.setState({ periodoStr });
    this.cargarDatos({
      fechaInicio: periodo?.[0]?.toISOString() ?? null,
      fechaFin:    periodo?.[1]?.toISOString() ?? null,
      embudoId:    embudoId    ?? null,
      vendedorId:  vendedorId  ?? null,
    });
  };

  cargarDatos = async ({ fechaInicio, fechaFin, embudoId, vendedorId } = {}) => {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "reportesCRM/rankingVendedores",
        { empresaId: this.props.empresaId, fechaInicio, fechaFin, embudoId, vendedorId },
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2) this.setState({ datosRanking: res.data.datos });
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  descargarExcel = () => {
    const { datosRanking } = this.state;
    const filas = datosRanking.map((d) => ({
      Posición:           d.posicion,
      Vendedor:           d.nombre,
      "Leads Ganados":    d.cantidadGanados,
      "Valor Ganado ($)": d.totalValor,
    }));
    const ws = XLSX.utils.json_to_sheet(filas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Ranking Equipo");
    XLSX.writeFile(wb, `Ranking_Equipo_CRM_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.xlsx`);
  };

  descargarPdf = async () => {
    this.setState({ loading: true });
    try {
      const { datosRanking, periodoStr } = this.state;

      const resEmpresa = await axios.post(
        "reportesCRM/datosEmpresaPdf",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      );
      const empresa = resEmpresa.data.success === 2 ? resEmpresa.data.empresa : {};

      const grafica = datosRanking.length
        ? buildBarras(datosRanking, (d) => d.totalValor, (d) => d.nombre, fmt)
        : null;

      const medalla = (pos) =>
        pos === 1 ? "1°" : pos === 2 ? "2°" : pos === 3 ? "3°" : `${pos}`;

      const terceraColumna = {
        border: [false, false, false, false],
        table: {
          widths: ["100%"],
          body: [
            [{ text: "Ranking de Equipo CRM", style: "tableHeader", alignment: "center" }],
            [{ text: periodoStr,              style: "textoChico",  alignment: "center" }],
            [{ text: "Fecha de Impresión:",   style: "subheader",   alignment: "center" }],
            [{ text: new Date().toLocaleDateString("es-MX"), style: "textoChico", alignment: "center" }],
          ],
        },
        layout: "noBorders",
      };

      const docDef = {
        pageSize:    "LETTER",
        pageMargins: [20, 20, 20, 40],
        content: [
          {
            style: "tableExample",
            table: {
              widths: ["15%", "55%", "30%"],
              body: [[...HeaderEmpresaCard(empresa, false, false, terceraColumna)]],
            },
          },
          { text: "Ranking de Equipo", style: "tableHeaderIzquierda", margin: [0, 6, 0, 8] },
          ...(grafica ? [
            { text: "Ranking por Monto Ganado", style: "subheader", margin: [0, 0, 0, 4] },
            grafica,
          ] : []),
          { text: "Tabla de Posiciones", style: "subheader", margin: [0, 4, 0, 4] },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["auto", "*", "auto", "auto"],
              body: [
                [
                  { text: "#",             style: "tituloTabla" },
                  { text: "Vendedor",      style: "tituloTabla" },
                  { text: "Leads Ganados", style: "tituloTabla" },
                  { text: "Valor Ganado",  style: "tituloTabla" },
                ],
                ...datosRanking.map((d) => [
                  { text: medalla(d.posicion), style: "textoTabla", alignment: "center", bold: d.posicion <= 3 },
                  { text: d.nombre,            style: "textoTabla" },
                  { text: d.cantidadGanados,   style: "textoTabla", alignment: "right" },
                  { text: fmt(d.totalValor),   style: "textoTabla", alignment: "right" },
                ]),
              ],
            },
            layout: {
              fillColor:  (i) => i % 2 === 0 && i !== 0 ? "#e8e8e8" : "#ffffff",
              hLineColor: () => "#adaaaa",
              vLineColor: () => "#adaaaa",
            },
          },
        ],
        images: { logo: empresa?.logo?.base64Completa ?? "" },
        styles: PDF_STYLES,
      };
      pdfMake.createPdf(docDef).download(`Ranking_Equipo_CRM_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.pdf`);
    } catch (e) {
      message.error("Hubo un error al generar el PDF.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading, datosRanking, embudos } = this.state;
    const { history } = this.props;

    const columns = [
      {
        title: "#", dataIndex: "posicion", width: 50, align: "center",
        render: (pos) => {
          if (pos === 1) return <TrophyOutlined style={{ color: "#faad14", fontSize: 20 }} />;
          if (pos === 2) return <TrophyOutlined style={{ color: "#bfbfbf", fontSize: 18 }} />;
          if (pos === 3) return <TrophyOutlined style={{ color: "#cd7f32", fontSize: 16 }} />;
          return <Text type="secondary">{pos}</Text>;
        },
      },
      { title: "Vendedor",      dataIndex: "nombre" },
      { title: "Leads Ganados", dataIndex: "cantidadGanados", align: "center" },
      { title: "Valor Ganado",  dataIndex: "totalValor", render: (v) => fmt(v), align: "right" },
    ];

    const datosBar = datosRanking.map((d) => ({
      nombre: d.nombre.length > 20 ? d.nombre.slice(0, 18) + "…" : d.nombre,
      Monto:  d.totalValor,
    }));

    return (
      <Form
        ref={this.formRef}
        onFinish={this.onFinish}
        initialValues={{ periodo: [moment().startOf("year"), moment()] }}
      >
        <PageHeader
          title={<span><TeamOutlined style={{ marginRight: 8, color: "#eb2f96" }} />Ranking de Equipo</span>}
          subTitle="Clasificación de vendedores por monto total ganado"
          onBack={() => history.push("/panel/crmReportes")}
          style={{ border: "1px solid rgb(235,237,240)", backgroundColor: "white", marginBottom: 15 }}
          extra={
            <Space wrap>
              {datosRanking.length > 0 && (
                <Tooltip title="Descargar Excel">
                  <span>
                    <ButtonItem verde icon={<FileExcelOutlined />} onClick={this.descargarExcel} />
                  </span>
                </Tooltip>
              )}
              {datosRanking.length > 0 && (
                <Tooltip title="Descargar PDF">
                  <span>
                    <ButtonItem rojo icon={<FilePdfOutlined />} onClick={this.descargarPdf} loading={loading} />
                  </span>
                </Tooltip>
              )}
              <ButtonItem azul htmlType="submit">Consultar</ButtonItem>
            </Space>
          }
        />

        {/* Cintillo de filtros */}
        <div style={{
          backgroundColor: "white", padding: 20, paddingTop: 5,
          borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)", marginBottom: 10,
        }}>
          <Tabs
            defaultActiveKey="1"
            style={{ margin: 0 }}
            tabBarExtraContent={{ left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1> }}
          >
            <TabPane key="1" tab="Periodo">
              <FormItem name="periodo" noStyle>
                <RangePickerItem />
              </FormItem>
            </TabPane>
            <TabPane key="2" tab="Embudo">
              <FormItem name="embudoId" noStyle>
                <SelectItem
                  placeholder="Todos los embudos"
                  allowClear
                  style={{ width: "90%" }}
                >
                  {embudos.map((e) => (
                    <Option key={e._id} value={e._id}>{e.nombreEmbudo}</Option>
                  ))}
                </SelectItem>
              </FormItem>
            </TabPane>
            <TabPane key="3" tab="Vendedor">
              <FormItem name="vendedorId" noStyle>
                <SelectVendedoresItem
                  headersToken={this.props.headersToken}
                  empresaId={this.props.empresaId}
                  placeholder="Todos los vendedores"
                  allowClear
                  style={{ width: "90%" }}
                />
              </FormItem>
            </TabPane>
          </Tabs>
        </div>

        <Spin spinning={loading}>
          {datosRanking.length === 0 && !loading ? (
            <Card style={CARD_STYLE}><Empty description="Sin datos de vendedores con oportunidades ganadas" /></Card>
          ) : (
            <Row gutter={[16, 16]}>
              <Col xs={24} lg={14}>
                <Card title="Ranking por Monto Ganado" style={CARD_STYLE}>
                  <div style={{ height: Math.max(280, datosRanking.length * 46) }}>
                    <ResponsiveBar
                      data={datosBar}
                      keys={["Monto"]} indexBy="nombre" layout="horizontal"
                      margin={{ top: 10, right: 100, bottom: 20, left: 140 }} padding={0.3}
                      colors={COLORES_NIVO} colorBy="indexValue" borderRadius={4}
                      axisBottom={{ format: (v) => `$${(v / 1000).toFixed(0)}k` }}
                      label={(d) => fmt(d.value)} labelSkipWidth={80}
                      tooltip={({ value, indexValue }) => (
                        <div style={{ background: "white", padding: "6px 12px", border: "1px solid #f0f0f0", borderRadius: 6 }}>
                          <strong>{indexValue}</strong>: {fmt(value)}
                        </div>
                      )}
                      theme={{ fontSize: 12 }}
                    />
                  </div>
                </Card>
              </Col>

              <Col xs={24} lg={10}>
                <Card title="Tabla de Posiciones" style={CARD_STYLE}>
                  <Table
                    dataSource={datosRanking}
                    columns={columns}
                    rowKey={(r) => r.usuarioId?.toString() ?? r.nombre}
                    size="small"
                    pagination={false}
                  />
                </Card>
              </Col>
            </Row>
          )}
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
});

export default withRouter(connect(mapStateToProps)(ReporteEquipoCRM));
